<template lang="pug">
  v-row
    template(v-if="loading.modules")
      v-col(cols=12)
        v-skeleton-loader(
          class="mx-auto"
          type="article@3"
        )
    v-col(cols=12)(
      v-for="moduleItem in modules"
      :key="moduleItem.id"
    )
      v-card.sdo-card.stock-item
        v-row(no-gutters)
          v-col(cols=12 md=4)
            v-card(
              color="grey lighten-5"
              flat
              @click="openModulePreview(moduleItem)"
            )
              v-card-text.pa-7
                div: strong {{ moduleItem.name }}
                p.grey--text {{ $tc('units', moduleItem.course_units_count) }}
                v-list(color="transparent").ma-0
                  v-list-item.px-0
                    v-list-item-avatar
                      v-icon mdi-desktop-classic
                    v-list-item-content
                      v-list-item-title Направленность
                      v-list-item-subtitle Искуственный интеллект
                  v-list-item.px-0
                    v-list-item-avatar
                      v-icon mdi-account-child-outline
                    v-list-item-content
                      v-list-item-title Возраст
                      v-list-item-subtitle {{ moduleItem.ageDistanceString }}

                p.mt-3 Доступные условия использования
                v-alert(color="warning darken-1" text prominent icon="mdi-check-bold").pa-7
                  .d-flex.title
                    span Цена за ученика
                    v-spacer
                    span {{ moduleItem.organization_special_conditions.price_per_user }} ₽
                  .d-flex.caption
                    template(
                      v-if="moduleItem.organization_special_conditions.is_escorted"
                    )
                      span С учетом сопровождения
                      v-spacer
                      span {{ moduleItem.organization_special_conditions.price_escort_per_user }}₽
                    template(v-else)
                      span Сопровождение недоступно
                      v-spacer
                      v-icon(
                        color="warning darken-1"
                        small
                      ) mdi-lock-outline
                .caption
                  v-icon mdi-information
                  span.ml-2 Цена и условия использования могут меняться,
                    |  автор модуля может задать конкретные условия для вас
          v-col(cols=12 md=8).d-flex.flex-column
            v-card-text.pa-5(height="100%")
              v-subheader
                span Курсы, в которые вы добавили модуль
                v-spacer
                v-btn(
                  fab
                  outlined
                  small
                  color="secondary"
                  @click="selectCourse"
                )
                  v-icon mdi-plus
              v-list.ma-0
                template(v-if="!moduleItem.courses.length")
                  v-list-item
                    v-alert(color="secondary" text dark).pa-5
                      span Вы еще никуда не добавили этот модуль...
                      v-btn(
                        outlined
                        color="secondary"
                        @click="selectCourse"
                      ).ml-5
                        span Выбрать курс

                template(v-else)
                  v-list-item(
                    v-for="course in moduleItem.courses"
                    :key="course.id"
                    :to="{ name: 'CourseUnits', params: { id: course.id } }"
                  )
                    v-list-item-avatar
                      v-img(
                        :src="course.image_file_url || require('@/assets/course-sample.png')"
                      )
                    v-list-item-content
                      v-list-item-title {{ course.title }}
                    v-list-item-action
                      v-btn(icon color="error" @click="deleteCourse(course.id, moduleItem.id)")
            v-card-actions.pb-9.pr-9
              v-spacer
              v-btn(
                color="error"
                @click="reject(moduleItem.id)"
              ) Отписаться
                v-icon(right ) mdi-delete

</template>

<script>
import ServerSelectListCourse from '@/components/InputFields/course/ServerSelectListCourse.vue';

import ModulePreview from '../components/ModulePreview.vue';

export default {
  props: {
    searchQ: { type: Object, default: null },
  },
  data() {
    return {
      modules: null,
      loading: {
        modules: false,
      },
    };
  },
  watch: {
    searchQ: {
      handler() {
        this.fetchModules();
      },
      deep: true,
    },
  },
  created() {
    this.fetchModules();
  },
  methods: {
    // async deleteCourse(courseId, moduleItemId) {
    //   const req = await this.$api.modules.reject(data.data[0].id);
    //   if (req.data) this.$toasted.success('Успешно');
    //   const idx = this.modules.findIndex((i) => i.id === id);
    //   this.modules.splice(idx, 1);
    //   this.$modals.close();
    // },
    async reject(id) {
      this.$modals.show('confirm-controller', {
        type: 'error',
        title: 'Удаление модуля',
        message: 'После удаление модуля вновь подписаться будет не возможно',
        method: async () => {
          const { data } = await this.$api.modules.getRequests({
            params: {
              'search[course_module_id]': id,
              'search[user_id]': this.$user.data.id,
            },
          });
          const req = await this.$api.modules.reject(data.data[0].id);
          if (req.data) this.$toasted.success('Модуль успешно удален');
          const idx = this.modules.findIndex((i) => i.id === id);
          this.modules.splice(idx, 1);
          this.$modals.close();
        },
      });
    },
    async fetchModules() {
      this.loading.modules = true;
      const { items } = await this.$api.modules.index({
        'search[name]': this.searchQ?.name,
        'search[organization_id]': this.$user.organization.id,
        expand: 'course_units_count,accepted_users_count,courses,organization_special_conditions',
      });
      this.modules = items;
      this.loading.modules = false;
    },
    openModulePreview(moduleItem) {
      this.$modals.show('generic-controller', {
        title: moduleItem.name,
        dialogProps: {
          width: 800,
        },
        component: ModulePreview,
        'component-props': {
          moduleItem,
          subscribed: true,
        },
      });
    },
    selectCourse() {
      const { $router, $modals } = this;
      $modals.show('generic-controller', {
        component: ServerSelectListCourse,
        'component-props': {
          serviceType: this.$conf.COURSE_SERVICE.organization,
          input(course) {
            $router.push({ name: 'CourseUnits', params: { id: course.id } });
            $modals.close();
          },
        },
      });
    },
  },
};
</script>
